import axios from 'axios';

const axiosInstance = axios.create({
  //https://api.antikbet.dev:1881/
  baseURL: 'https://api.antikbet.dev:1881/',
});

// İSTEK ATARKEN: Token ekle
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// NOT: Response interceptor'ı BURAYA EKLEME.
// 401 yönetimi ve x-user-permissions senkronizasyonu
// PermissionContext.js içindeki interceptor tarafından yapılıyor.
// İki ayrı interceptor çakışmasın diye burada sadece request interceptor var.

export default axiosInstance;